import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CxAdvFiltersContainerComponent } from './cx-adv-filters.component';
import { CxAdvFiltersCreatorComponent } from './cx-adv-filters-creator/cx-adv-filters-creator.component';
import { CxAdvFiltersListComponent } from './cx-adv-filters-list/cx-adv-filters-list.component';
import { CxAdvFiltersService } from './cx-adv-filters.service';
import { CxAdvFiltersDataService } from './cx-adv-filters-data.service';
import { CxAdvFiltersFieldsComponent } from './cx-adv-filters-fields/cx-adv-filters-fields.component';
import { FormsModule } from '@angular/forms';
// import { ChipsModule } from 'primeng/chips';
// import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from '@shared/modules/dropdown/dropdown';
import { CalendarModule } from '@shared/modules/calendar/calendar';
import { CxViewNameComponent } from './modal/view-name-modal.component';
import { RadioButtonModule } from '../radio/radio';
import { ChipsModule } from '../chips/chips';
import { DialogModule } from '../dialog/dialog';
import { CxShowableFieldPipe } from './pipes/cx-only-showable.pipe';
import { FilterPipe } from './pipes/filterBy.pipe';
import { CxShowableGroupPipe } from './pipes/cx-only-showable-group.pipe';
import { MultiSelectModule } from '../multiselect/multiselect';

@NgModule({
  declarations: [
    FilterPipe,
    CxShowableFieldPipe,
    CxViewNameComponent,
    CxShowableGroupPipe,
    CxAdvFiltersFieldsComponent,
    CxAdvFiltersContainerComponent,
    CxAdvFiltersCreatorComponent,
    CxAdvFiltersListComponent
  ],
  imports: [
    MultiSelectModule,
    DialogModule,
    ChipsModule,
    CalendarModule,
    DropdownModule,
    // ChipsModule,
    RadioButtonModule,
    CommonModule,
    FormsModule,
  ],
  providers: [ CxAdvFiltersService, CxAdvFiltersDataService ],
  exports: [
    CxAdvFiltersFieldsComponent,
    CxAdvFiltersContainerComponent,
    CxAdvFiltersCreatorComponent,
    CxAdvFiltersListComponent
  ]
})
export class CxAdvFiltersModule { }
